export default {
      id: "brightness_2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#brightness_2",
      toString: function () {
        return this.url;
      }
    }